import { useEffect, useState } from 'react'
import { getBannerCoupons, BannerCoupon } from '../../api/couponApi'

/**
 * The offers cleared for broadcast, shared by everything on the landing page
 * that shows them (the ticker and the "why order today" cards).
 *
 * The in-flight promise is cached at module scope so two components mounting in
 * the same paint make ONE request between them. The answer is identical for
 * every visitor — the service caches it for ten minutes — so there is nothing
 * per-user to keep apart here.
 */
let inFlight: Promise<BannerCoupon[]> | null = null

function load(): Promise<BannerCoupon[]> {
  // getBannerCoupons never rejects (it answers [] on failure), so a cached
  // promise can't leave later callers stuck with an error.
  if (!inFlight) inFlight = getBannerCoupons()
  return inFlight
}

export function useBannerCoupons(): { coupons: BannerCoupon[]; loading: boolean } {
  const [coupons, setCoupons] = useState<BannerCoupon[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let alive = true
    load().then((list) => {
      if (!alive) return
      setCoupons(list)
      setLoading(false)
    })
    return () => { alive = false }
  }, [])

  return { coupons, loading }
}
